import { APP_VERSION } from '../data/AppInfo';

const INSTALLATION_ID_KEY = 'azanAnalyticsInstallationId';
const LAST_SENT_KEY = 'azanAnalyticsLastSent';
const REPORT_INTERVAL_MS = 24 * 60 * 60 * 1000;
const INITIAL_DELAY_MS = 12 * 1000;

const detectDeviceType = (userAgent) => {
    if (/SmartTV|SMART-TV|HbbTV|Tizen|Web0S|WebOS|NetCast|VIDAA|AFT[A-Z0-9]+|Fire TV|Android TV|BRAVIA|Viera|PhilipsTV|CrKey/i.test(userAgent)) return 'tv';
    if (/iPad|Tablet|PlayBook|Silk/i.test(userAgent)) return 'tablet';
    if (/Mobi|Android|iPhone/i.test(userAgent)) return 'mobile';
    return 'computer';
};

const createInstallationId = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    window.crypto?.getRandomValues?.(bytes);
    if (bytes.some(Boolean)) return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `ac-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const getInstallationId = () => {
    let installationId = localStorage.getItem(INSTALLATION_ID_KEY);
    if (!installationId) {
        installationId = createInstallationId();
        localStorage.setItem(INSTALLATION_ID_KEY, installationId);
    }
    return installationId;
};

const reportIsDue = () => {
    const lastSent = Number(localStorage.getItem(LAST_SENT_KEY) || 0);
    return !lastSent || Date.now() - lastSent >= REPORT_INTERVAL_MS;
};

const sendReport = async (getSettings) => {
    if (!navigator.onLine || !reportIsDue()) return;

    const settings = getSettings();
    if (!settings) return;

    const payload = {
        installationId: getInstallationId(),
        deviceType: detectDeviceType(navigator.userAgent || ''),
        language: settings.deviceSettings?.language || navigator.language || 'unknown',
        appVersion: APP_VERSION,
        calculationMethod: settings.calculationSettings?.method || 'unknown'
    };

    try {
        const response = await fetch('/analytics/report.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            credentials: 'omit',
            cache: 'no-store',
            keepalive: true
        });
        if (response.ok) localStorage.setItem(LAST_SENT_KEY, String(Date.now()));
    } catch (error) {
        // Offline and older TV browsers retry on the next launch or online event.
    }
};

export const startDailyAnalytics = (getSettings) => {
    if (process.env.NODE_ENV !== 'production') return () => {};

    const attempt = () => sendReport(getSettings);
    const timer = window.setTimeout(attempt, INITIAL_DELAY_MS);
    window.addEventListener('online', attempt);

    return () => {
        window.clearTimeout(timer);
        window.removeEventListener('online', attempt);
    };
};
